module.exports = __webpack_public_path__ + "img/layout_and_composition_splash.f1b916ca.jpg";